import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { StartImpersonationResponse } from "@/api/user-management/userManagement.mutations.types";

interface ImpersonationState {
  createdAt: string | null;
  userId: string | null;
  tenantId: string | null;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  userType: string | null;
  isEntityLogin: boolean | null;
  isMainAppLogin: boolean | null;
  subDomain: string | null;
  modules: string[] | null;
  userName: string | null;
  userRoles: string[] | null;
  entityName: string | null;
  isAppLevel: boolean | null;
  allEntities: boolean | null;
  entityIds: string[] | null;
  impersonationSessionId: string | null;
  impersonatedUserName: string | null;
  startedAt: string | null;
  isImpersonating: boolean;
  startImpersonation: (data: StartImpersonationResponse["data"]) => void;
  resetImpersonationStore: () => void;
}

const initialState = {
  createdAt: null,
  userId: null,
  tenantId: null,
  email: null,
  firstName: null,
  lastName: null,
  userType: null,
  isEntityLogin: null,
  isMainAppLogin: null,
  subDomain: null,
  modules: null,
  userName: null,
  userRoles: null,
  entityName: null,
  isAppLevel: null,
  allEntities: null,
  entityIds: null,
  impersonationSessionId: null,
  impersonatedUserName: null,
  startedAt: null,
  isImpersonating: false,
};

export const useImpersonationStore = create<ImpersonationState>()(
  persist(
    (set) => ({
      ...initialState,
      startImpersonation: (data) =>
        set({
          impersonationSessionId: data.sessionId,
          createdAt: data.createdAt,
          userId: data.userId,
          tenantId: data.tenantId,
          email: data.email,
          firstName: data.firstName,
          lastName: data.lastName,
          userType: data.userType,
          isEntityLogin: data.isEntityLogin,
          isMainAppLogin: data.isMainAppLogin,
          subDomain: data.subDomain,
          modules: data.modules,
          userName: data.userName,
          userRoles: data.userRoles,
          entityName: data.entityName,
          isAppLevel: data.isAppLevel ?? false,
          allEntities: data.allEntities ?? false,
          entityIds: data.entityIds ?? [],
          impersonatedUserName: data.userName,
          startedAt: new Date().toISOString(),
          isImpersonating: true,
        }),
      resetImpersonationStore: () => set(initialState),
    }),
    {
      name: "impersonation-store",
    },
  ),
);
